import { render, staticRenderFns } from "./BarraSuperior.vue?vue&type=template&id=16a8091c&scoped=true"
import script from "./BarraSuperior.vue?vue&type=script&lang=js"
export * from "./BarraSuperior.vue?vue&type=script&lang=js"
import style0 from "./BarraSuperior.vue?vue&type=style&index=0&id=16a8091c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a8091c",
  null
  
)

export default component.exports